import React from 'react'
import SectionLabel from '../SectionLabel/SectionLabel'
import Styles from '../Content/Content.css'
import Button from '../Button/Button'

const Spotlight = () => {
  return (
    <section className="pt-10 pb-10 md:pt-20 md:pb-20 bg-color-arizona-blue spotlight-container">
      <div className="container text-white">
        <SectionLabel
          heading={'Spotlight on Quest'}
          body={'When we said you can get involved with research right away, we meant it.'}
        />
        <div className="flex max-md:flex-col pt-8">
          <div className="basis-1/2 video-section h-fit">
            <div className="video-container2">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/7NxfKr_oZJc?si=ArA_mQPuvvwF1m3p"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div className="basis-1/2 md:pl-16 max-md:pt-6">
            <div>
              The{' '}
              <a
                linkId="quest-project"
                target="_blank"
                className="blue-link"
                href="https://frankehonors.arizona.edu/academics/research/quest-project"
              >
                Quest Project
              </a>{' '}
              is your chance to pursue a research project you care about with guidance from a
              faculty mentor at our top-20 public research institution.
            </div>
            <div className="relative pt-8 max-w-[90px] max-md:ml-auto max-md:mr-auto md:max-w-[200px]">
              <div className="line horizontal-line bloom"></div>
            </div>
            <div className="text-3xl max-md:text-center font-black condensed pt-10">Top 20</div>
            <div className="max-md:text-center font-semibold">Public Research Institution</div>
            <div className="italic max-md:text-center ">- National Science Foundation</div>
            <div className="spotlight-button-wrap pt-10 flex max-md:justify-center">
              <Button
                linkId="quest-experiences"
                className="border-white"
                link="https://youtube.com/playlist?list=PLMrsYOKrP2J-OdwBCKLpRUofTr8gs3TGp&si=gr-ytE1TjH3c7VM8"
              >
                Quest Experiences
              </Button>
            </div>
          </div>
        </div>
        <div className="pt-10 font-semibold">
          <p>“It’s amazing to make new connections and learn more about the research process.”</p>
          <p>— Mira, Psychology and Business Management</p>
        </div>
      </div>
    </section>
  )
}

export default Spotlight
